import { apiProvider } from "./utilities/provider";

export type ReferralConversionRow = {
  ReferredUserID: number;
  Status: string;
  PlanInterval: string;
  MonthsCredited: number;
  EarnedCents: number;
  PaidCents: number;
};

export type ReferralsGetResponse = {
  Enrolled: boolean;
  Code: string;

  TotalEarnedCents: number;
  TotalPaidCents: number;
  TotalOwedCents: number;

  Conversions: ReferralConversionRow[];
};

export const referralsApi = {
  async get(): Promise<ReferralsGetResponse> {
    const res: any = await apiProvider.getAll("referrals");

    if (res?.data?.data) {
      return res.data.data;
    }

    if (res?.data) {
      return res.data;
    }

    return res;
  },

  async enroll(): Promise<{ Code: string }> {
    const res: any = await apiProvider.post("referrals/enroll");

    if (res?.data?.data) {
      return res.data.data;
    }

    if (res?.data) {
      return res.data;
    }

    return res;
  },
};
